module.exports = function() {
	return new Worker(__webpack_public_path__ + "compiler.worker.js");
};


// WEBPACK FOOTER //
// ./src/compiler.worker.js